var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.user)?_c('div',{attrs:{"id":"content"}},[_c('DRNav'),_c('router-view')],1):_c('div',[_c('Login')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }